/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedSuklDosageFormListSchema } from '../models/PagedSuklDosageFormListSchema';
import type { PagedSuklMagistraliterProductReadSchema } from '../models/PagedSuklMagistraliterProductReadSchema';
import type { PagedSuklMedicalDeviceListSchema } from '../models/PagedSuklMedicalDeviceListSchema';
import type { PagedSuklMedicinalProductListSchema } from '../models/PagedSuklMedicinalProductListSchema';
import type { PagedSuklRouteOfAdministrationListSchema } from '../models/PagedSuklRouteOfAdministrationListSchema';
import type { SuklMagistraliterProductCreateSchema } from '../models/SuklMagistraliterProductCreateSchema';
import type { SuklMagistraliterProductReadSchema } from '../models/SuklMagistraliterProductReadSchema';
import type { SuklMagistraliterProductUpdateSchema } from '../models/SuklMagistraliterProductUpdateSchema';
import type { SuklReimbursementStatus } from '../models/SuklReimbursementStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuklApi {
    /**
     * Create Magistraliter Product
     * Create a magistraliter (SÚKL IPLP) product for the user's company. Required Permission: create_sukl_magistraliter_product
     * @returns SuklMagistraliterProductReadSchema Created
     * @throws ApiError
     */
    public static insuranceCreateMagistraliterProductPost({
        requestBody,
    }: {
        requestBody: SuklMagistraliterProductCreateSchema,
    }): CancelablePromise<SuklMagistraliterProductReadSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/sukl/magistraliter-products/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Magistraliter Product List
     * List the company's magistraliter (SÚKL IPLP) products. Required Permission: get_sukl_magistraliter_product_list
     * @returns PagedSuklMagistraliterProductReadSchema OK
     * @throws ApiError
     */
    public static insuranceGetMagistraliterProductListGet({
        search,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSuklMagistraliterProductReadSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/magistraliter-products/',
            query: {
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Delete Magistraliter Product
     * Delete a magistraliter (SÚKL IPLP) product. Required Permission: delete_sukl_magistraliter_product
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteMagistraliterProductDelete({
        productId,
    }: {
        productId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/sukl/magistraliter-products/{product_id}/',
            path: {
                'product_id': productId,
            },
        });
    }
    /**
     * Get Magistraliter Product
     * Get one magistraliter (SÚKL IPLP) product. Required Permission: get_sukl_magistraliter_product_detail
     * @returns SuklMagistraliterProductReadSchema OK
     * @throws ApiError
     */
    public static insuranceGetMagistraliterProductGet({
        productId,
    }: {
        productId: string,
    }): CancelablePromise<SuklMagistraliterProductReadSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/magistraliter-products/{product_id}/',
            path: {
                'product_id': productId,
            },
        });
    }
    /**
     * Update Magistraliter Product
     * Fully update a magistraliter (SÚKL IPLP) product. Required Permission: update_sukl_magistraliter_product
     * @returns SuklMagistraliterProductReadSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateMagistraliterProductPut({
        productId,
        requestBody,
    }: {
        productId: string,
        requestBody: SuklMagistraliterProductUpdateSchema,
    }): CancelablePromise<SuklMagistraliterProductReadSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/sukl/magistraliter-products/{product_id}/',
            path: {
                'product_id': productId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Dosage Form List
     * List SÚKL dosage forms (search). Required Permission: create_eprescription
     * @returns PagedSuklDosageFormListSchema OK
     * @throws ApiError
     */
    public static insuranceGetDosageFormListGet({
        search,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSuklDosageFormListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/dosage-forms/',
            query: {
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Medical Device List
     * List SÚKL medical devices (search + filter). Required Permission: create_evoucher
     * @returns PagedSuklMedicalDeviceListSchema OK
     * @throws ApiError
     */
    public static insuranceGetMedicalDeviceListGet({
        search,
        group,
        isPrescribable,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        group?: (string | null),
        isPrescribable?: (boolean | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSuklMedicalDeviceListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/medical-devices/',
            query: {
                'search': search,
                'group': group,
                'is_prescribable': isPrescribable,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Medicinal Product List
     * List SÚKL medicinal products (search + filter). Required Permission: create_eprescription
     * @returns PagedSuklMedicinalProductListSchema OK
     * @throws ApiError
     */
    public static insuranceGetMedicinalProductListGet({
        search,
        isPrescribable,
        hasValidRegistration,
        suppliedLast6M,
        reimbursementStatus,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        isPrescribable?: (boolean | null),
        hasValidRegistration?: (boolean | null),
        suppliedLast6M?: (boolean | null),
        reimbursementStatus?: (SuklReimbursementStatus | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSuklMedicinalProductListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/medicinal-products/',
            query: {
                'search': search,
                'is_prescribable': isPrescribable,
                'has_valid_registration': hasValidRegistration,
                'supplied_last_6m': suppliedLast6M,
                'reimbursement_status': reimbursementStatus,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Route Of Administration List
     * List SÚKL routes of administration (search). Required Permission: create_eprescription
     * @returns PagedSuklRouteOfAdministrationListSchema OK
     * @throws ApiError
     */
    public static insuranceGetRouteOfAdministrationListGet({
        search,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSuklRouteOfAdministrationListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sukl/routes-of-administration/',
            query: {
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
